/** Accounting sub-account types */
export enum AccountingSubAccountEnum {
  /** Debit turnover sub-account */
  DEBIT_TURNOVER = 'DEBIT_TURNOVER',
  /** Credit turnover sub-account */
  CREDIT_TURNOVER = 'CREDIT_TURNOVER',
  /** Balance turnover sub-account */
  BALANCE_TURNOVER = 'BALANCE_TURNOVER',
  /** Initial balance sub-account */
  INITIAL_BALANCE = 'INITIAL_BALANCE',
}
